import { Component, OnInit, Input } from '@angular/core';

@Component({
	selector: 'portals-response-length-bar',
	templateUrl: './response-length-bar.component.html',
	styleUrls: ['./response-length-bar.component.scss'],
})
export class ResponseLengthBarComponent implements OnInit {
	@Input() data: any;

	audioAverage!: number;
	videoAverage!: number;
	textAverage!: number;
	calcPercentage(value: number, max: number): string {
		return `calc(${(value / max) * 100}%)`;
	}

	ngOnInit() {
		if (this.data) {
			this.audioAverage = this.data.audio.average;
			this.videoAverage = this.data.video.average;
			this.textAverage = this.data.text.average;
		}
	}
}
